import axios from "axios";

export default {
  namespaced: true,
  state: {
    properties: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    propertiesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_PROPERTIES(state, payload) {
      state.properties = payload;
      state.isReceiving = false;
    },
    RECEIVING_PROPERTIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_PROPERTY(state, payload) {
      let find = state.properties.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { properties: [payload, ...state.properties] });
      }
      else {
        let index = state.properties.findIndex(x => x._id === payload._id);
        state.properties.splice(index, 1, payload);
      }
    },
    RECEIVING_PROPERTY(state) {
      state.isReceiving = true;
    },
    UPDATED_PROPERTY(state, payload) {
      let index = state.properties.findIndex(property => property._id === payload._id);
      state = Object.assign(state, {
        properties: state.properties.map((property, i) => {
          if (i === index) {
            return Object.assign({}, property, payload);
          }
          return property;
        }),
        isUpdating: false,
        propertiesMessage: 'Properties has been updating!',
      })
    },
    UPDATING_PROPERTY(state) {
      state.isUpdating = true;
    },
    DELETED_PROPERTY(state, payload) {
      let indexToDelete = state.properties.findIndex(property => property._id === payload._id);
      let properties = [...state.properties];
      properties.splice(indexToDelete, 1);
      state = Object.assign(state, {
        properties: [...properties],
        isDeleting: false,
        idToDelete: null,
        propertiesMessage: 'Property has been Deleted!',
      });
    },
    DELETING_PROPERTY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getPropertiesRequest({dispatch}) {
      dispatch("receivingProperties");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/get/properties';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(response => {
        dispatch("receiveProperties", response.data);
      })
    },
    async getPropertyRequest({dispatch}, id) {
      dispatch("receivingProperties");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/property/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveProperty", response.data);
      })
    },
    async updatePropertyRequest({dispatch}, payload) {
      dispatch("updatingProperty");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/property/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (response) {
        dispatch("updateProperty", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updatePropertyImageRequest({dispatch}, payload) {
      dispatch("updatingProperty");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/property/image/' + id;
      let data = new FormData();
      data.append('image', payload.propertyimage, payload.imagename); 
      delete payload['propertyimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateProperty", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updatePropertyUnitRequest({dispatch}, payload) {
      try{
        dispatch("receivingProperty");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/propertyunit/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveProperty", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertPropertyRequest({dispatch}, payload) {
      dispatch("receivingProperty");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/property';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveProperty", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertPropertyWithImageRequest({dispatch}, payload) {
      dispatch("receivingProperty");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/property/withimage';
      let data = new FormData();
      data.append('image', payload.propertyimage, payload.imagename); 
      delete payload['propertyimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveProperty", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertPropertyUnitRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/propertyunit/' + payload.propertyid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    deletePropertyRequest({dispatch}, payload) {
      dispatch("deletingProperty", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/property/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteProperty", {_id: payload._id});
      })
    },
    async deletePropertyUnitRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/propertyunit/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveProperties({commit}, payload) {
      commit("RECEIVED_PROPERTIES", payload)
    },
    receivingProperties({commit}) {
      commit("RECEIVING_PROPERTIES")
    },
    receiveProperty({commit}, payload) {
      commit("RECEIVED_PROPERTY", payload)
    },
    receivingProperty({commit}) {
      commit("RECEIVING_PROPERTY")
    },
    updateProperty({commit}, payload) {
      commit("UPDATED_PROPERTY", payload)
    },
    updatingProperty({commit}) {
      commit("UPDATING_PROPERTY")
    },
    deleteProperty({commit}, payload) {
      commit("DELETED_PROPERTY", payload)
    },
    deletingProperty({commit}, payload) {
      commit("DELETING_PROPERTY", payload)
    }
  },
};
